import { FuelAndEnergyDetails } from 'models/Farmbox/fuelAndEnergy.model';

export const stage3InitialData = async (
  commodityId: string | undefined,
  fetchFuelAndEnergyData: (pathParams: {
    commodityId?: string;
  }) => Promise<FuelAndEnergyDetails | undefined>
) => {
  const initialValues: FuelAndEnergyDetails | undefined =
    await fetchFuelAndEnergyData({ commodityId });

  return initialValues?.commodity || initialValues?.location
    ? { ...new FuelAndEnergyDetails(), ...initialValues }
    : new FuelAndEnergyDetails();
};
